import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true         如果为true 不会显示在菜单栏中（默认false）
 * alwaysShow: true     如果设置为true，将始终显示根菜单
 *                      如果未设置alwaysShow，则当项目有多个子路径时，
 *                      它将变成嵌套模式，否则不显示根菜单
 * redirect: noRedirect  如果set noRedirect将不会在breadcrumb中重定向
 * name:'router-name'    名称由<keep alive>使用（必须设置！！！）
 * meta : {
    roles: ['admin','editor']    控制页面角色（可以设置多个角色）
    title: 'title'               在边栏和面包屑中显示的名称（推荐集）
    icon: 'svg-name'/'el-icon-x' 图标显示在侧栏中
    breadcrumb: false            如果设置为false，则项目将隐藏在breadcrumb中（默认值为true）
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes 通用路由表 （所有角色都显示的路由页面）
 * a base page that does not have permission requirements 没有权限要求的公共页面
 * all roles can be accessed  所有角色都可以访问
 */
export const constantRoutes = [
  {
    path:'/login',
    name:'Login',
    component: () => import('@/views/login/index'),
    hidden: true
  }, {
    path: '/register',
    name:'Register',
    component: () => import('@/views/register/index'),
    hidden: true
  },
  {
    path: '/CodeLog',
    name:'CodeLog',
    component: () => import('@/views/code/CodeLog.vue'),
    hidden: true
  },
  {
    path: '/QaCode',
    name:'QaCode',
    component: () => import('@/views/code/QaCode.vue'),
    hidden: true
  },{
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },{
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'Home',
      component: () => import('@/views/home/index'),
      meta: { title: 'home', icon: 'dashboard' },
      hidden: true
    }]
  },{
    path: '/',
    component: Layout,
    children: [{
        path: 'waybill',
        name: 'Waybill',
        component: () => import('@/views/waybill/index'),
        meta: { title: 'waybill', icon: 'waybill' }
      }]
  },{
    path: '/',
    component: Layout,
    children: [{
        path: 'addWaybill',
        name: 'AddWaybill',
        component: () => import('@/views/waybill/sonviews/addWaybill'),
        meta: { title: 'addWaybill' },
        hidden: true
      }]
  },{
    path: '/',
    component: Layout,
    children: [{
        path: 'editWaybill',
        name: 'EditWaybill',
        component: () => import('@/views/waybill/sonviews/editWaybill'),
        meta: { title: 'editWaybill'},
        hidden: true
      }]
  },{
    path: '/',
    component: Layout,
    children: [{
        path: 'modifyWaybill',
        name: 'ModifyWaybill',
        component: () => import('@/views/waybill/sonviews/modifyWaybillNo'),
        meta: { title: 'modifyWaybill'},
        hidden: true
      }]
  },{
    path: '/',
    component: Layout,
    children: [{
        path: 'waybillPrinting',
        name: 'WaybillPrinting',
        component: () => import('@/views/waybill/sonviews/waybillPrinting'),
        meta: { title: 'waybillPrinting' },
        hidden: true
      }]
  },{
    path: '/',
    component: Layout,
    children: [{
        path: 'batchImport',
        name: 'BatchImport',
        component: () => import('@/views/waybill/sonviews/batchImport'),
        meta: { title: 'batchImport' },
        hidden: true
      }]
  },{
    path: '/',
    component: Layout,
    children: [
      {
        path: 'routing',
        name: 'Routing',
        component: () => import('@/views/routing/index'),
        meta: { title: 'routing', icon: 'routing' }
      }
    ]
  },

  {
    path: '/',
    component: Layout,
    children: [{
        path: 'address',
        name: 'Address',
        component: () => import('@/views/address/index'),
        meta: { title: 'address', icon: 'address' }
      }]
  },
  {
    path: '/',
    component: Layout,
    children: [{
        path: 'receipt',
        name: 'Receipt',
        component: () => import('@/views/receipt/index'),
        meta: { title: 'receipt',icon: 'receipt'  }
      }]
  },
  {
    path: '/',
    component: Layout,
    children: [{
        path: 'system',
        name: 'System',
        component: () => import('@/views/system/index'),
        meta: { title: 'system', icon: 'system' },
        hidden: true
      }]
  },
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: 'generate',
        name: 'generate',
        component: () => import('@/views/generate/index'),
        meta: { title: 'generate', icon: 'routing',  roles: ['admin'] }
      }
    ]
  },
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: 'Balance',
        name: 'Balance',
        component: () => import('@/views/Balance/index'),
        meta: { title: 'Balance', icon: 'balance',  }
      }
    ]
  },
  // {
  //   path: '/',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'charges',
  //       name: 'charges',
  //       component: () => import('@/views/charges/index'),
  //       meta: { title: 'charges', icon: 'shou_hui',  roles: ['admin'] }
  //     }
  //   ]
  // },
  {
    path: 'external-link',
    component: Layout,
    children: [
      {
        path: 'http://cxc.com.hk/',
        meta: { title: '官網連結', icon: 'list_logo' }
      }
    ]
  },
  // {
  //   path: '/',
  //   component: Layout,
  //   children: [
  //     {
  //       path: '',
  //       name:'客服',
  //       meta: { title: '聯繫客服', icon: 'kefun' }
  //     }
  //   ]
  // },

   // {
  //   path: '/nested',
  //   component: Layout,
  //   redirect: '/nested/menu1',
  //   name: 'Nested',
  //   meta: {
  //     title: 'Nested',
  //     icon: 'nested'
  //   },
  //   children: [{
  //       path: 'menu1',
  //       component: () => import('@/views/nested/menu1/index'), // Parent router-view
  //       name: 'Menu1',
  //       meta: { title: 'Menu1' },
  //       children: [{
  //           path: 'menu1-1',
  //           component: () => import('@/views/nested/menu1/menu1-1'),
  //           name: 'Menu1-1',
  //           meta: { title: 'Menu1-1' }
  //         },
  //         {
  //           path: 'menu1-2',
  //           component: () => import('@/views/nested/menu1/menu1-2'),
  //           name: 'Menu1-2',
  //           meta: { title: 'Menu1-2' },
  //           children: [
  //             {
  //               path: 'menu1-2-1',
  //               component: () => import('@/views/nested/menu1/menu1-2/menu1-2-1'),
  //               name: 'Menu1-2-1',
  //               meta: { title: 'Menu1-2-1' }
  //             },
  //             {
  //               path: 'menu1-2-2',
  //               component: () => import('@/views/nested/menu1/menu1-2/menu1-2-2'),
  //               name: 'Menu1-2-2',
  //               meta: { title: 'Menu1-2-2' }
  //             }
  //           ]
  //         },
  //         {
  //           path: 'menu1-3',
  //           component: () => import('@/views/nested/menu1/menu1-3'),
  //           name: 'Menu1-3',
  //           meta: { title: 'Menu1-3' }
  //         }
  //       ]
  //     },
  //     {
  //       path: 'menu2',
  //       component: () => import('@/views/nested/menu2/index'),
  //       name: 'Menu2',
  //       meta: { title: 'menu2' }
  //     }
  //   ]
  // },



  // 404 page must be placed at the end 404页必须放在末尾  !!!
  { path: '*', redirect: '/404', hidden: true }
]

//实例化vue的时候只挂载constantRouter
const createRouter = () => new Router({
  mode: 'history', // 需要服务支持
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // 重置路由器
}

export default router
